import { ReactNode, createContext, useContext } from 'react';

interface IOwnership {
    userId: string | number | null;
    children: ReactNode;
}

interface OwnershipContextType {
    userId: string | number | null;
}

const OwnershipContext = createContext<OwnershipContextType>({
    userId: null
});

/**
 * Hook to access ownership context in child components
 */
export const useOwnership = () => {
    const context = useContext(OwnershipContext);
    if (!context) {
        throw new Error('useOwnership must be used within an OwnedBy component');
    }
    return context;
};

/**
 * A Higher Order Component that provides ownership context to its children
 * This can be used in conjunction with the Permissions component to allow
 * editing by the owner regardless of their role.
 * 
 * @param userId - The ID of the owner of this content
 * @param children - The child components
 */
const Ownership = ({ userId, children }: IOwnership) => {
    return (
        <OwnershipContext.Provider value={{ userId }}>
            {children}
        </OwnershipContext.Provider>
    );
};

export default Ownership; 